<template>
  <div>
    <Dialog
      id="dialog-intervention-info"
      :visible.sync="show"
      :style="{ width: $isMobile() ? '100vw' : '40vw' }"
      v-bind:class="[{ 'p-dialog-maximized': $isMobile() }]"
      :modal="true"
      :closable="false"
      :header="'Informações da Intervenção'"
    >
      <div class="p-col-12" v-if="this.service">
        <div>
          <h5>{{ this.service.entity_name }}</h5>
        </div>
        <div>
          <b>Pat:</b>
          {{ this.service.pat_number }}
        </div>
        <div v-if="this.service.pat_brand">
          <b>Marca do Equipamento:</b>
          {{ this.service.pat_brand }}
        </div>
        <div v-if="this.service.pat_model">
          <b>Modelo do Equipamento:</b>
          {{ this.service.pat_model }}
        </div>
        <div v-if="this.service.pat_serial_number">
          <b>Número de Série do Equipamento:</b>
          {{ this.service.pat_serial_number }}
        </div>
        <div v-if="this.service.pat_v_ref">
          <b>V/ Referência:</b>
          {{ this.service.pat_v_ref }}
        </div>
        <div v-if="this.service.pat_nref">
          <b>Localização:</b>
          {{ this.service.pat_nref }}
        </div>
        <div v-if="this.service.pat_problem">
          <b>Problema: </b>
          {{ this.service.pat_problem }}
        </div>
        <div v-if="this.service.pat_title">
          <b>Observações: </b>
          {{ this.service.pat_title }}
        </div>
        <div v-if="this.service.pat_transport_document_code">
          <b>Guia de transporte: </b>
          {{ this.service.pat_transport_document_code }}
        </div>
        <div v-if="this.service.pat_transport_document_date">
          <b>Data da Guia de Transporte: </b>
          {{ this.service.pat_transport_document_date }}
        </div>
        <div v-if="this.service.equipament_status">
          <b>Estado do Equipamento: </b>
          {{ this.service.equipament_status }}
        </div>
        <h4>Cliente:</h4>
        <div>
        <b>Nome: </b>
          {{ this.service.contact_name }}
        </div>
        <div>
        <b>Telefone: </b>
          <a :href="'tel:' + service.contact_phone">{{ this.service.contact_phone }}</a>
        </div>
        <div v-if="this.service.contact_phone2">
        <b>Telefone 2: </b>
        <a :href="'tel:' + service.contact_phone2">{{ this.service.contact_phone2 }}</a>
        </div>
        <h4>Morada:</h4>
        <div>
          {{ this.service.localization.address }} <br />
          {{ this.service.localization.zip_code }} <br />
          {{ this.service.localization.local }}
        </div>
        <div class="p-mt-1">
          <Button
            label="Ver no mapa"
            class="p-button-success"
            icon="pi pi-map-marker"
            @click="goToAdrress"
          />
        </div>

        <div class="p-mt-3">
          <h4>Peças:</h4>
            <div v-if="this.service && this.service.parts && this.service.parts.length > 0">
              <DataTable :value="this.service.parts" responsiveLayout="scroll">
                <Column field="quantity" header="Qtd" style="width: 80px">
                <template #body="slotProps">
                  <strong>{{ slotProps.data.quantity }}</strong>
                </template>
                </Column>
                <Column field="ref" header="Referência">
                <template #body="slotProps">
                  <strong>{{ slotProps.data.ref?.trim() }}</strong>
                </template>
                </Column>
                <Column field="design" header="Designação" />
                <Column field="warehouse_name" header="Armazém">
                <template #body="slotProps">
                  <span v-if="slotProps.data.destination_warehouse_id">
                  {{ slotProps.data.destination_warehouse_id }} - {{ slotProps.data.destination_warehouse_name }}
                  </span>
                  <span v-else class="p-text-secondary">-</span>
                  <span v-if="slotProps.data.pat_nref">
                    Localização: {{ slotProps.data.pat_nref }}
                  </span>
                </template>
                </Column>
              </DataTable>
            </div>
            <div v-else class="p-text-secondary">
              <i class="pi pi-minus"></i> Sem peças
            </div>
        </div>

      </div>

      <template #footer>
         <Button
          label="Detalhes do PAT"
          icon="pi pi-box"
          class="p-button-primary"
          @click="goToPat"
        />
        <Button
          label="Fechar"
          icon="pi pi-times"
          class="p-button-danger"
          @click="close"
        />
      </template>
    </Dialog>
  </div>
</template>
<script>

export default {
  name: "InterventionInfo",
  props: ["show", "service"],
  methods: {
    close() {
      return this.$emit("close");
    },
    goToAdrress() {
      let address = this.service.localization.address;
      let zipCode = this.service.localization.zip_code;
      let local = this.service.localization.local;
      window.open(
        `http://maps.google.com/?q=${address}, ${zipCode}, ${local}`,
        "_blank"
      );
    },
    goToInstallationSheet() {
      let route = this.$router.resolve({
        path: `/task-installation-sheet/${
          this.service.taskId != undefined
            ? this.service.taskId
            : this.service.endServiceTaskId
        }`,
      });
      window.open(route.href, "_blank");
    },
    goToPat() {
      this.$router.push(`/pats/${this.service.pat_number}`);
    },
  },
};
</script>
